









































































































import { Component, Prop } from 'vue-property-decorator'
import { RawLocation } from 'vue-router'
import RouterHelper from '../../mixins/RouterHelper.vue'
import { getDownloadData } from '@/request/apis/common'
import { downloadUrls } from '@/types/Task'

@Component
export default class DropdownGroup extends RouterHelper {
  @Prop() resultList!: any[]
  @Prop() jobId!: string

  private downloadList: downloadUrls = {
    params_download: '',
    data_download: '',
    metadata_csv: '',
    differential_expression: {
      marker_gene_list: ''
    },
    gene_set_enrichment: {
      cell_pathway: '',
      gene_list: '',
      group_pathway: ''
    },
    cell_communication: {
      p_value: '',
      mean: '',
      count_network: ''
    }
  }

  /**
   * 从结果页面跳转到下一步页面
   */
  private gotoNextStep (nextPage: string) {
    let resultRoute: RawLocation = this.getCompleteRouteByPathObject({
      name: nextPage,
      params: { id: this.jobId }
    })
    this.$router.push(resultRoute)
  }

  // 下一步默认跳转resultList的第一个选项
  private defaultNextStepHandler () {
    this.gotoNextStep(this.resultList[0])
  }

  // 根据job id获取下载链接
  public async getDownloadData (id: string) {
    this.downloadList = await getDownloadData(null, id).start()
  }

  // 默认下载结果
  private downloadData () {
    window.open(this.downloadList.data_download || this.downloadList.params_download, '_self')
  }

  mounted () {
    this.getDownloadData(this.jobId)
  }
}
